import styled from "styled-components";
import { Button } from "../Common/styles.common";

export const BackIcon = styled.div`
  cursor: pointer;
  padding: 8px;
  margin-right: 8px;
`;

export const Card = styled.div`
  background: white;
  border-radius: 20px;
  padding: 16px;
  margin: 16px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
`;

export const CardTitle = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: #212121;
  margin-bottom: 16px;
`;

export const Dropdown = styled.select`
  width: 100%;
  padding: 12px 16px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  font-size: 14px;
  color: #212121;
  background: white;
  margin-bottom: 16px;
  outline: none;

  &:focus {
    border-color: #e23744;
  }

  &:disabled {
    background: #f5f5f5;
    color: #9e9e9e;
  }
`;

export const TextInput = styled.input`
  width: 100%;
  padding: 12px 16px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  font-size: 14px;
  color: #212121;
  margin-bottom: 16px;
  outline: none;

  &:focus {
    border-color: #e23744;
  }

  &::placeholder {
    color: #9e9e9e;
  }
`;

export const UploadTilesContainer = styled.div`
  display: flex;
  gap: 12px;
  margin-top: 16px;
`;

export const UploadTile = styled.div`
  flex: 1;
  border: 2px dashed
    ${(props) =>
      props.disabled ? "#e0e0e0" : props.hasFile ? "#e23744" : "#e0e0e0"};
  border-radius: 8px;
  padding: 24px 16px;
  text-align: center;
  cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
  transition: all 0.2s;
  background: ${(props) =>
    props.disabled ? "#f5f5f5" : props.hasFile ? "#fff5f5" : "white"};
  opacity: ${(props) => (props.disabled ? "0.5" : "1")};

  &:hover {
    border-color: ${(props) => (props.disabled ? "#e0e0e0" : "#e23744")};
    background: ${(props) => (props.disabled ? "#f5f5f5" : "#fff5f5")};
  }

  input[type="file"] {
    display: none;
  }
`;

export const UploadIcon = styled.div`
  font-size: 32px;
  color: ${(props) => (props.hasFile ? "#e23744" : "#9e9e9e")};
  margin-bottom: 8px;
`;

export const UploadLabel = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: ${(props) => (props.hasFile ? "#e23744" : "#616161")};
  margin-bottom: 4px;
`;

export const FileName = styled.div`
  font-size: 12px;
  color: #9e9e9e;
  margin-top: 8px;
  word-break: break-all;
`;

export const FileTypeLabel = styled.div`
  font-size: 12px;
  color: #9e9e9e;
`;

export const FixedFooter = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: white;
  border-top: 1px solid #f2f4f7;
  padding: 16px;
  box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.08);
  z-index: 100;
`;

export const SubmitButton = styled(Button)`
  width: 100%;
  padding: 14px;
  font-size: 16px;
  font-weight: 600;
  background: #ef4f5f;
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;

  &:disabled {
    background: #e0e0e0;
    color: #9e9e9e;
    cursor: not-allowed;
  }

  &:hover:not(:disabled) {
    background: #d43f4f;
  }
`;

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`;

export const ModalContent = styled.div`
  background: white;
  border-radius: 20px;
  padding: 32px 24px;
  width: 90%;
  max-width: 400px;
  position: relative;
  text-align: center;
`;

export const CloseButton = styled.button`
  position: absolute;
  top: 16px;
  right: 16px;
  background: none;
  border: none;
  font-size: 24px;
  color: #9e9e9e;
  cursor: pointer;
  padding: 0;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    color: #212121;
  }
`;

export const SuccessIcon = styled.div`
  width: 80px;
  height: 80px;
  margin: 0 auto 24px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ModalTitle = styled.div`
  font-size: 20px;
  font-weight: 700;
  color: #212121;
  margin-bottom: 24px;
`;

export const ModalButton = styled.button`
  background: none;
  border: none;
  color: #ef4f5f;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  padding: 12px 32px;

  &:hover {
    opacity: 0.8;
  }
`;

export const ErrorText = styled.div`
  color: #c62828;
  font-size: 12px;
  margin-top: -12px;
  margin-bottom: 16px;
  padding-left: 4px;
`;

export const FilePreviewContainer = styled.div`
  margin-top: 24px;
  padding-top: 16px;
  border-top: 1px solid #e0e0e0;
`;

export const PreviewTitle = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: #212121;
  margin-bottom: 12px;
`;

export const FilePreviewItem = styled.div`
  display: flex;
  align-items: center;
  padding: 12px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  margin-bottom: 8px;
  background: white;
`;

export const ImagePreview = styled.img`
  width: 50px;
  height: 50px;
  object-fit: cover;
  border-radius: 4px;
  margin-right: 12px;
`;

export const PdfPreviewIcon = styled.div`
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 32px;
  background: #f5f5f5;
  border-radius: 4px;
  margin-right: 12px;
`;

export const FilePreviewInfo = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
`;

export const PreviewFileName = styled.div`
  font-size: 14px;
  font-weight: 500;
  color: #212121;
  margin-bottom: 4px;
  word-break: break-all;
`;

export const PreviewFileSize = styled.div`
  font-size: 12px;
  color: #9e9e9e;
`;

export const RemoveButton = styled.button`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: none;
  background: #ffebee;
  color: #e23744;
  font-size: 24px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;

  &:hover {
    background: #e23744;
    color: white;
  }
`;

export const ScrollableContent = styled.div`
  height: calc(100vh - 120px);
  overflow-y: auto;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
  padding-bottom: 16px;
`;

export const ErrorModalContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  text-align: center;
`;

export const ErrorIconContainer = styled.div`
  width: 150px;
  height: 150px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ErrorIconImage = styled.img`
  width: 100px;
  height: 100px;
`;

export const ErrorIcon = styled.div`
  font-size: 48px;
  color: #e23744;
`;

export const ErrorMessage = styled.div`
  font-size: 20px;
  font-weight: 800;
  color: #212121;
  line-height: 1.5;
`;

export const ContactInfoBox = styled.div`
  background: #f5f5f5;
  padding: 20px;
  border-radius: 8px;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const ContactTitle = styled.div`
  font-size: 14px;
  color: #616161;
  font-weight: 800;
  text-align: center;
`;

export const ContactDetail = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ContactLabel = styled.span`
  font-size: 14px;
  color: #616161;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

export const ContactValue = styled.span`
  font-size: 16px;
  color: #212121;
  font-weight: 600;
`;
